export const SK = 'rq:app-data';

export async function loadApp() {
  try { const v = localStorage.getItem(SK); if (v) return JSON.parse(v); }
  catch(e) { console.warn('Primary data corrupt, trying backup');
    try { const b = localStorage.getItem(SK+'-bak'); if (b) { localStorage.setItem(SK, b); return JSON.parse(b); } } catch {} }
  return null;
}

let _saveFailToast = null;
export function setSaveFailToast(fn) { _saveFailToast = fn; }

export async function saveApp(d) {
  try { const v = JSON.stringify(d); const old = localStorage.getItem(SK); if (old) localStorage.setItem(SK+'-bak', old); localStorage.setItem(SK, v); }
  catch(e) { console.error('Storage save error:', e); if (_saveFailToast) _saveFailToast(); }
}
